import { isPlatformBrowser } from '@angular/common'
import { Injectable, PLATFORM_ID } from '@angular/core'

import type {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
} from '@ngx-translate/core'

@Injectable()
export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    if (
      params.translateService.getCurrentLang() !== 'qqx' &&
      isPlatformBrowser(PLATFORM_ID)
    ) {
      console.warn(`Missing translation for key: ${params.key}`)
    }
    return params.key
  }
}
